// extracted by mini-css-extract-plugin
export var container = "NewHereSection-module--container--8rYtO";
export var description = "NewHereSection-module--description--I2Pal";
export var title = "NewHereSection-module--title--hlN12";
export var wrapper = "NewHereSection-module--wrapper--XVxJw";